<template>
  <div v-if="!this.deleting" class="max-w-sm font-thin m-2 py-1 px-1  flex flex-row items-center bg-gradient-to-r from-blue-300 to-blue-200 rounded-lg text-blue-900 text-sm shadow-lg shadow-blue-200 border-2 border-blue-500 hover:bg-blue-500 hover:shadow-2xl transition-all duration-300 ring-offset-2 focus:ring-2 focus:ring-blue-400">
    <router-link :to="{ name: todosOrDone(), params: { category: text }}" class="truncate " >{{text}}</router-link>
    <button class="text-pink-900 ml-1.5 mr-0.5" @click="deleteCategory()"> x </button>
  </div>
</template>

<script>

import { db } from "@/firebaseConfig";
export default {
  name: 'CategoryButton',
  props: {
      text:String,
      id:String
  },
  data: function() {
    return {
        deleting: false
    }
  },

  methods: {
      deleteCategory() {
          db.collection('categories').doc(this.id).delete()
      },
      todosOrDone: function() {
          const currentURL = window.location.href
          const todosOrDone = currentURL.substring(currentURL.lastIndexOf('/') + 1)
          return todosOrDone+"Category"

      }
  }
  
}
</script>

<style>

</style>